class CartRecommendedProducts extends HTMLElement {
  constructor() {
    super()
  }

  setVariables() {
    this.productIds = this.getAttribute('data-product-ids')
    this.limit = this.getAttribute('data-limit')
    this.content = this.querySelector('[data-render]')
  }

  connectedCallback() {
    this.setVariables()
    if (!this.productIds) return

    this.initSection()
    this.addEventListener('CARD_LOADED', this.activateContent.bind(this))
  }

  disconnectedCallback() {
    this.removeEventListener('CARD_LOADED', this.activateContent.bind(this))
  }

  async initSection() {
    const productIds = this.productIds?.split(',') || []
    if (productIds.length < 1) return
    const fetchPromises = productIds.map(async (id) => {
      const response = await this.getRecommendedProducts(id)
      return response
    })
    const facetTagConfigurations = await Promise.all(fetchPromises)
    let allArray = []
    Array.from(facetTagConfigurations).forEach((array) => {
      const itemArray =
        array?.products?.map((product) => product.handle) || []
      allArray = allArray.concat(itemArray)
    })
    allArray = this.shuffleArray([...allArray])
    const recommendLimit = parseInt(this.limit || '6')
    this.productHandles = allArray.slice(0, recommendLimit)
    if (this.productHandles.length > 0) this.renderContent()
  }

  shuffleArray(array) {
    Array.from(array).forEach((_item, i) => {
      const j = Math.floor(Math.random() * (i + 1))
      const temp = array[i]
      array[i] = array[j]
      array[j] = temp
    })

    return array
  }

  renderContent () {
    Array.from(this.productHandles).forEach(handle => {
      this.content.insertAdjacentHTML('beforeend', `
        <dynamic-product-card handle='${handle}'></dynamic-product-card>
      `)
    })
  }

  activateContent() {
    this.classList.remove('hidden')
    this.initCarousel()
  }

  initCarousel() {
    const carousel = new window.themeVendor.Flickity(this.content, {
      wrapAround: !0,
      pageDots: !1,
      cellAlign: "center",
      contain: !0,
      prevNextButtons: !0
    }, 1e3)

    setTimeout(function() {
      carousel.resize()
    }, 3000);
  }

  async getRecommendedProducts (id) {
    try {
      const recommendLimit = parseInt(this.limit || '6')
      const response = await fetch(
        `/recommendations/products.json?product_id=${id}&limit=${recommendLimit}`
      )
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`)
      }
      return await response.json()
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }
}

customElements.define('cart-recommended-products', CartRecommendedProducts)
